import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initFrontPageAnimations() {
  // Register ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Helper function to check if elements exist
  const exists = (selector) => document.querySelector(selector) !== null;

  // Shark animations
  if (exists(".shark-icon") && exists(".megascreen-block")) {
    gsap.to(".shark-icon", {
        x: 400,
        y: 300,
        rotation: 10,
        ease: "none",
        scrollTrigger: {
            trigger: ".megascreen-block",
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
  }

  if (exists(".shark-icon2") && exists(".megascreen-block")) {
    gsap.to(".shark-icon2", {
        y: -200,
        x: 350,
        rotation: -15,
        ease: "none",
        scrollTrigger: {
            trigger: ".megascreen-block",
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
  }

  // Blog bubbles
  if (exists(".latest-blogs-block")) {
    const bubbles = gsap.utils.toArray(".latest-blogs-block .bubble-icon");
    if (bubbles.length) {
      bubbles.forEach((bubble) => {
          let speed = parseFloat(bubble.getAttribute("data-speed")) || 1;
          let distance = bubble.classList.contains('--large') ? -200 :
              bubble.classList.contains('--medium') ? -240 :
              bubble.classList.contains('--small') ? -260 : -280;

          gsap.to(bubble, {
              y: distance * speed,
              ease: "sine.inOut",
              scrollTrigger: {
                  trigger: ".latest-blogs-block",
                  start: "top bottom",
                  end: "bottom top",
                  scrub: 0.8,
              }
          });
      });
    }
  }

  // FAQ bubbles
  if (exists(".faqs-block")) {
    const bubbles = gsap.utils.toArray(".faqs-block .bubble-icon");
    if (bubbles.length) {
      bubbles.forEach((bubble) => {
          let speed = parseFloat(bubble.getAttribute("data-speed"));
          if (!isNaN(speed)) {
            gsap.to(bubble, {
                y: -300 * speed,
                x: 30 * speed,
                ease: "none",
                scrollTrigger: {
                    trigger: ".faqs-block",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });
          }
      });
    }
  }

  // Slider bubbles
  if (exists(".slider-block")) {
    const bubbles = gsap.utils.toArray(".slider-block .bubble-icon");
    if (bubbles.length) {
      bubbles.forEach((bubble) => {
          let scale = bubble.getAttribute("data-speed");
          if (scale) {
            gsap.to(bubble, {
                y: -300 * parseFloat(scale),
                x: 30 * parseFloat(scale),
                ease: "none",
                scrollTrigger: {
                    trigger: ".slider-block",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });
          }
      });
    }
  }

  // Fish icon
  if (exists(".fish-icon") && exists(".highlight-block")) {
    gsap.to(".fish-icon", {
        y: -80,
        x: 300,
        rotation: -12,
        ease: "none",
        scrollTrigger: {
            trigger: ".highlight-block",
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
  }
}